import { Gender } from "../Gender";

export default () => ({
    gender: "men",
    init: function () {
        this.updateGender();
    },
    setGender(gender) {
        Gender.setGender(gender);
    },
    updateGender() {
        this.gender = Gender.getGender();
    },
});
